import NfcCardsList from './NfcCardsList';

export default NfcCardsList;
